var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntrapost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 177.927,
    height: 177.927,
    viewBox: "0 0 177.927 177.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407",
    transform: "translate(-240.602 -337.532)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 125.813,
    height: 125.813,
    transform: "translate(240.602 426.495) rotate(-45)",
    fill: "#2c4795"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 4.603,
    height: 19.301,
    transform: "translate(284.646 405.006)",
    fill: "#d1b334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M312.555,424.306h-4.426l-8.795-11.772v11.772h-4.6v-19.3h4.412l8.793,11.775V405.006h4.62Z",
    fill: "#d1b334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M332.229,409.277h-5.707v15.029h-4.608V409.277h-5.721V405h16.029Z",
    fill: "#d1b334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M346.169,416.944c3.457-.546,5.383-2.7,5.383-5.762,0-3.807-2.532-6.173-7.308-6.173h-8.381v19.3h4.588v-7.234h.677l5.1,7.232H351.7Zm-5.718-3.72v-4.037H344.2c1.619,0,2.667.636,2.667,2s-1.023,2.028-2.667,2.028Z",
    fill: "#d1b334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M374.482,424.306h-4.9l-1.458-4.046h-7.67l-1.457,4.046h-4.817l7.4-19.3h5.505Zm-12.546-8.217h4.7l-2.346-6.508Z",
    fill: "#d1b334"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M295.023,441.1v6.52h-4.6v-19.3h8.273c4.771,0,7.286,2.569,7.286,6.44,0,3.8-2.522,6.341-7.248,6.341Zm0-8.6v4.5h3.6c1.651,0,2.672-.772,2.672-2.231s-1.019-2.267-2.672-2.267Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M329.712,437.974a9.748,9.748,0,0,1-9.472,10.015h0q-.348.01-.7-.005a10.01,10.01,0,0,1-.255-20.018h.255a9.747,9.747,0,0,1,10.168,9.307v0c.01.233.012.467.005.7m-15.551,0a5.381,5.381,0,1,0,5.379-5.6,5.257,5.257,0,0,0-5.388,5.124v0c0,.156,0,.313.009.469",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M347.2,433.8a10.749,10.749,0,0,0-5.528-1.621c-1.751,0-3.033.6-3.033,1.739,0,1.211,1.835,1.5,3.972,1.875l.8.139c3.751.642,6.107,2.4,6.107,5.556,0,4.588-3.957,6.508-8.094,6.508a14.391,14.391,0,0,1-8.49-2.455l2.3-3.752a10.826,10.826,0,0,0,6.23,2.026c1.737,0,3.061-.594,3.061-1.791,0-1.16-1.3-1.492-3.817-1.877l-.971-.152c-3.973-.62-6.124-2.411-6.056-5.885.067-3.75,3.265-6.122,7.771-6.122a14.824,14.824,0,0,1,7.8,2.034Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M368.709,432.6H363v15.027H358.4V432.6h-5.72v-4.272H368.7Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntrapost);
export default __webpack_public_path__ + "static/media/intrapost.ce9eccb96fcc1d32ef2fd1e0d63fce7f.svg";
export { ForwardRef as ReactComponent };